// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cG92","col":"styles_col__2kN8O","actions":"styles_actions__3NNEk","conflict":"styles_conflict__3a2TP"};